import { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import ExpandMoreIcon from 'svgIcons/ExpandMore'

interface IFProps {
  selectValue: string
  placeholder: string
  isFocused: boolean
  icon?: ReactNode
  isErrors?: boolean
  disabled?: boolean
  onClick: () => void
}

const SelectBox: FC<IFProps> = ({
  placeholder,
  selectValue,
  icon,
  isFocused,
  isErrors,
  disabled = false,
  onClick,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onClick()
    }
  }

  return (
    <StyledWrapper
      onClick={handleClick}
      data-focused={isFocused}
      data-errors={isErrors}
      data-disabled={disabled}
    >
      {selectValue ? (
        <p>
          {icon && <i className="icon-select-option">{icon}</i>}
          {selectValue}
        </p>
      ) : (
        <span aria-describedby="placeholder">{placeholder}</span>
      )}
      <i className="icon-arrow">
        <ExpandMoreIcon />
      </i>
    </StyledWrapper>
  )
}

export default SelectBox

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 50px;
    padding: 13px 10px 13px 15px;
    border-radius: 8px;
    border: solid 1px ${theme.line.line_2};
    background-color: ${theme.background.bg_8};
    display: flex;
    align-items: center;
    justify-content: space-between;

    &[data-focused='true'] {
      border: solid 1px ${theme.color.primary_2};
    }

    &[data-errors='true'] {
      border: solid 1px ${theme.color.error_1};

      & > p,
      & > span {
        color: ${theme.color.error_1};
      }
    }

    &[data-disabled='true'] {
      background-color: ${theme.background.bg_3};

      & > p,
      & > span {
        color: ${theme.color.text_2};
      }
    }

    & > [aria-describedby='placeholder'],
    & > p {
      height: 24px;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.64px;
      text-align: left;
    }

    & > [aria-describedby='placeholder'] {
      font-weight: normal;
      color: ${theme.color.text_3};
    }

    & > p {
      font-weight: 500;
      color: ${theme.color.text_1};
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;

      & > .icon-select-option {
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    & > i {
      width: 24px;
      height: 24px;
      text-align: center;
    }
  `}
`
